import apiClient from './apiClient';

export interface FM131 {
  fm131_01?: string;
  fm131_02?: number;
  fm131_11: string;
  fm131_12: string;
  fm131_121: string;
  fm131_13: string;
  fm131_14?: string;
  fm131_15: number;
  fm131_16?: string;
  fm131_17?: number;
  fm131_18?: string;
  fm131_19?: string;
  fm131_20?: number;
}

export interface FM130 {
  fm130_01?: string;
  fm130_11: string;
  fm130_12?: number;
  fm130_13: string;
  fm130_14?: number;
  /** Server-calculated total including tax; response/display only. */
  fm130_142?: number;
  fm130_15?: string;
  fm130_16: string;
  fm130_17?: boolean;
  fm130_18: string;
  fm130_19: number;
  fm130_20: string;
  fm130_21?: number;
  fm130_22: string;
  /** Legacy display/accounting flag; preserved as read-only response data. */
  fm130_23?: boolean;
  fm130_231: number;
  fm130_24?: number;
  fm130_25?: number;
  fm130_43?: boolean;
  fm130_80?: 'N' | 'P';
  /** Server audit date; never accepted from an editable control. */
  fm130_92?: string;
  details?: FM131[];
}

export interface M203SaveRequest { master: FM130; details: FM131[] }
export interface M203ListResponse { data: FM130[]; total: number; page: number; size: number }

const normalizeMaster = (master: FM130): FM130 => ({
  ...master,
  fm130_11: typeof master.fm130_11 === 'string' ? master.fm130_11.slice(0, 10) : master.fm130_11,
});

const wireRequest = (request: M203SaveRequest): M203SaveRequest => ({
  ...request,
  master: {
    ...request.master,
    fm130_11: /^\d{4}-\d{2}-\d{2}$/.test(request.master.fm130_11)
      ? `${request.master.fm130_11}T00:00:00+08:00`
      : request.master.fm130_11,
  },
});

export const m203Api = {
  async list(page = 1, size = 100): Promise<M203ListResponse> {
    const result: M203ListResponse = (await apiClient.get('/api/m203', { params: { page, size } })).data;
    return { ...result, data: result.data.map(normalizeMaster) };
  },
  async get(id: string): Promise<FM130> {
    return normalizeMaster((await apiClient.get(`/api/m203/${encodeURIComponent(id)}`)).data);
  },
  async create(request: M203SaveRequest): Promise<FM130> {
    return normalizeMaster((await apiClient.post('/api/m203', wireRequest(request))).data);
  },
  async update(id: string, request: M203SaveRequest): Promise<FM130> {
    return normalizeMaster((await apiClient.put(`/api/m203/${encodeURIComponent(id)}`, wireRequest(request))).data);
  },
  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/m203/${encodeURIComponent(id)}`, { data: { confirmed: true } });
  },
  async copy(id: string): Promise<M203SaveRequest> {
    const result: M203SaveRequest = (await apiClient.get(`/api/m203/${encodeURIComponent(id)}/copy`)).data;
    return { ...result, master: normalizeMaster(result.master) };
  },
};
